import CustomPalette from './CustomPalette'
import CustomContextPadProvider from './CustomContextPadProvider'

/** @description Packs our custom bpmn module */
export default {
  __init__: [
    'paletteProvider',
    'contextPadProvider'
  ],
  paletteProvider: ['type', CustomPalette],
  contextPadProvider: ['type', CustomContextPadProvider]
}
